import LightBox from './Lightbox';

export default LightBox;
